enum UserActionCode {
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  ViewProfile = 'VIEW_PROFILE',
  ViewPatientProfile = 'VIEW_PATIENT_PROFILE',
  EditProfile = 'EDIT_PROFILE',
  EditPatientProfile = 'EDIT_PATIENT_PROFILE',
  AddEvent = 'ADD_EVENT',
  AddDiagnosticReport = 'ADD_DIAGNOSTIC_REPORT',
  ViewDiagnosticReport = 'VIEW_DIAGNOSTIC_REPORT',
  AddMediaDetection = 'ADD_MEDIA_DETECTION',
  EditMediaDetection = 'EDIT_MEDIA_DETECTION',
  DeleteMediaDetection = 'DELETE_MEDIA_DETECTION'
}

export default UserActionCode;
